<template>
    <div class="contentWrap boxed ">
          <div class="d2-section">
            <div class="d2-section__header">
              <h2 class="d2-h2">
                <!-- <img class="mobiIcon" :src="PopularIcon_gamebox" alt=""/> -->
                <span class="text_color">{{$t("all")}} {{$t("hotpicks")}}</span>
              </h2>
            </div>
            <div v-if="isLoad === false">
              <svg class="spinner" viewBox="0 0 50 50">
                <circle
                  class="path"
                  cx="25"
                  cy="25"
                  r="20"
                  fill="none"
                  stroke-width="5"
                ></circle>
              </svg>
            </div>
            <div class="d2-section__content" v-if="isLoad === true">
              <div class=" itemCollection row">
                <div class="col-6 col-md-2 col-lg-2 col-sm-4 d2-appItem d2-appItem--noAnim" v-for="pop in pagePopular_gamebox" :key="pop.key">
                  <a class="d2__inner app " data-toggle="modal" data-target="#contentModal" v-on:click="getDetail(pop.content_id)">
                    <div class="d2-appItem__thumb">
                       <div v-if="pop.content_type === 'application/x-zip-compressed' && pop.parent_category === 'Game'" class="htmlBadge">
                          <img src="../../assets/gamebox/imgs/html5-badge.png"/>
                        </div>
                      <img class="img_wrp" :src="pop.thumbnail_url" alt="" />
                    </div>
                    <div class="d2-appItem__info">
                      <span v-if="lang_gamebox !== 'english'">
                        <h4 class="d2-h4" v-if="pop[`cont_name_${lang_gamebox}`] !== ''">{{ pop[`cont_name_${lang_gamebox}`] }}</h4>
                        <h4 class="d2-h4" v-else>{{ pop[`cont_name_english`] }}</h4>
                      </span>
                      <span v-else>
                        <h4 class="d2-h4">{{ pop[`cont_name_english`] }}</h4>
                      </span>
                      <div>
                          <star-rating :inline="true" :star-size="14" :read-only="true" :increment="0.01"  active-color="#FFCF00" :show-rating="false" :border-width="3" border-color="#FFCF00" :rounded-corners="false" inactive-color="transparent" :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]" :rating="Number(pop.rating)"></star-rating>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
      </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);

export default {
  data() {
    return {
      query: [],
      isLoad: false
    };
  },
  components:{
    StarRating
  },
  computed: mapGetters([
    "pagePopular_gamebox",
    "PopularIcon_gamebox",
    "country_gamebox",
    "lang_gamebox"
  ]),
  created() {
    this.isLoad = false;
    this.fetchPagePopular_gamebox();
    this.getPopular();
  },
  methods: {
    ...mapActions(["fetchPagePopular_gamebox"]),
    getDetail(id) {
      this.$root.$emit("getDetail", id);
    },
    getPopular() {
      setTimeout(() => {
        this.isLoad = true;
      }, 2500);
    }
  }
};
</script>

<style scoped>
.main_title {
  color: black;
}
.main_part div {
  display: inline-block;
  padding: 0 3px;
  color: black;
}
.browse_link {
  color: black;
}

.icon {
  height: 32px;
  width: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/gamebox/Popular.vue